<template>
  <div class="home main-content">
    <MainHeader :navName="'拍卖'"></MainHeader>
    <div class="content">
      <div class="btns">
        <div class="btns-back" @click="onBack"><Icon class="icon-back" size="35" style="font-weight: bold" type="ios-arrow-back" />返回 <span>{{database.info.title}}</span></div>
        <Button class="btns-item"  icon="ios-print" type="primary" @click="onPrint">打印</Button>
        <div class="btns-time" v-if="curProgress == 1">
          <div>投标剩余时间：</div>
          <div>{{timeLeft.d}}:{{timeLeft.h}}:{{timeLeft.m}}:{{timeLeft.s}}</div>
        </div>
        <div class="btns-time" v-if="curProgress == 2">
          <div>开盘剩余时间：</div>
          <div>{{timeLeft.d}}:{{timeLeft.h}}:{{timeLeft.m}}:{{timeLeft.s}}</div>
        </div>
      </div>
      <div class="download-info">
        <div class="download-title">
          <div class="download-full-btn"><img src="../assets/images/icon-zip.png">下载完整文档</div>
          <div class="download-desc">批次<span> NO{{$route.query.no}} <span style="font-weight: bold"> {{$route.query.form}}</span></span></div>
          <div class="download-excel-btn"><Button type="success">导出Excel</Button></div>
        </div>
        <div class="download-weight">批次重量: <span>{{$route.query.w}}</span>Ct</div>
      </div>
<!--      <div class="tab">-->
<!--        <div class="tab-item tab-item-type1" @click="switchType(1)" :class="options.type == 1?'active': ''">列表</div>-->
<!--        <div class="tab-item tab-item-type2" @click="switchType(2)" :class="options.type == 2?'active': ''">我的购物车</div>-->
<!--        <div class="tab-item tab-item-type3" @click="switchType(3)" :class="options.type == 3?'active': ''">我的订单</div>-->
<!--      </div>-->
<!--      <div class="tab-bottom" :style="tabBottomStyle">-->
<!--        <div class="tab-total" v-if="options.type == 2">共计：<span style="font-weight: bold">999</span>Ct</div>-->
<!--      </div>-->
      <div class="table">
        <section v-if="options.type == 1" >
          <table  style="width: 100%;">
            <tr class="tab-title">
              <th>N</th>
              <th>石头ID</th>
              <th>数字 <br>扫描</th>
              <th>重量 <br>Ct</th>
              <th>ZVI <br>结果</th>
              <th>颜色</th>
              <th>蓝色 <br>UV</th>
              <th>黄色 <br>UV</th>
              <th>黄色</th>
              <th>类型</th>
              <th>棕色 </th>
              <th>备注价值 <br>$ </th>
              <th></th>
              <th>价格 <br>$/Ct</th>
            </tr>
            <tr class="tab-list" v-if="database.list && database.list.length > 0" v-for="(item, index) in database.list" :key="index">
              <td>{{index + 1}}</td>
              <td>{{item.certno}}</td>
              <td>
                <div class="icon-zip-box" @click="onDown(item)">
                  <img src="../assets/images/icon-zip.png" >
                </div>
              </td>
              <td>{{item.d_size}}</td>
              <td>{{item.clarity}}</td>
              <td>{{item.color}}</td>
              <td>{{item.size}}</td>
              <td></td>
              <td></td>
              <td>{{item.auctionPrize || '-'}}</td>
              <td ></td>
              <td style="width: 80px"><Input ></Input></td>
              <td><Button type="info">保存备注</Button></td>
              <td>-</td>
            </tr>
            <tr v-if="!database.list || database.list.length <= 0">
              <td  colspan="10">暂无数据~</td>
            </tr>
          </table>
        </section>
      </div>
      <div class="bottom-tip">
        *请注意，此处提供的Sarine银河扫描和Zvi Yehuda色度计测量数据是由Sarine TechnologiesLimited在其位于莫斯科的认可实验室创建的
      </div>
      <MainFooter></MainFooter>
    </div>
    <Modal v-model="modals.registrationModal" class-name="vertical-center-modal" @on-ok="onRegistration">
      <p>确认我愿意参加由上市股份公司雅罗莎举办的这次拍卖会?</p>
    </Modal>
    <Modal v-model="modals.scheduleMode" width="300"
           class-name="schedule-modal"
           footer-hide>
      <p slot="header" style="color:#fff;text-align:center; font-weight: bold;">
        <span>时间表</span>
      </p>
      <div style="text-align:center">
        <div class="schedule-item">
          <div class="schedule-item-name">登记时间</div>
          <div class="schedule-item-value">2月27日15:25</div>
        </div>
        <div class="schedule-item">
          <div class="schedule-item-name">投标</div>
          <div class="schedule-item-value">2月27日15:25</div>
        </div>
        <div class="schedule-item">
          <div class="schedule-item-name">结果</div>
          <div class="schedule-item-value">2月27日15:25</div>
        </div>
      </div>
    </Modal>
    <Modal v-model="modals.viewMode" class-name="vertical-center-modal">
      <p style="font-size: 16px">你要看<span style="color: #2d8cf0">第{{modals.viewModeIndex + 1}}批</span>石头吗？</p>
    </Modal>
    <Modal v-model="modals.downloadScanMode" class-name="vertical-center-modal">
      <p style="text-align: center; margin-top: 10px">确定下载 <span style="color: #2d8cf0">第{{modals.viewModeIndex + 1}}批石头</span>的数码扫描？</p>
      <div style="text-align: center;margin-top: 20px">
        <Button style="margin: 0 10px" @click="modals.downloadScanMode = false">取消</Button>
        <Button style="margin: 0 10px" type="success" icon="md-cloud-download">下载</Button>
      </div>
      <div slot="footer">
        <p style="text-align: center">*请注意,此处提供的 Sarine galax扫描和Zvi yehuda测色仪是由 Sarine技术有限公司在其在莫斯科的认可实验室中创建的。</p>
      </div>
    </Modal>
  </div>
</template>

<script>
import MainHeader from '../public/MainHeader'
import MainFooter from '../public/MainFooter'
import Core from '@/until/core'
import moment from 'moment'
const postDownLoadFile = function (options) { // 下载Excel
  /* eslint-disable */
  const config = $.extend(true, { method: 'post' }, options)
  const $iframe = $('<iframe id="down-file-iframe" />')
  const $form = $('<form target="down-file-iframe" method="' + config.method + '" />')
  $form.attr('action', config.url)
  for (let key in config.data) {
    $form.append('<input type="hidden" name="' + key + '" value="' + config.data[key] + '" />')
  }
  $iframe.append($form)
  $(document.body).append($iframe)
  $form[0].submit()
  $iframe.remove()
}
export default {
  name: 'ListDetails',
  data () {
    return {
      curSysTime: '',
      timeLeft: {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
        isEnd: false
      },
      modals: {
        registrationModal: false,
        scheduleMode: false,
        viewMode: false,
        viewModeText: '',
        viewModeIndex: 0,
        downloadScanMode: false
      },
      options: {
        type: 1
      },
      database: {
        activity_id: '',
        id: '',
        list: [],
        myOrder: [],
        myCar: [],
        info: {}
      },
      curProgress: 0
    }
  },
  computed: {
    selectList () {
      const data = this.database.list
      const prize = {
        num: 0,
        total: 0
      }
      for (const item of data) {
        if (parseInt(item.auction) === 11) {
          prize.num += 1
          prize.total += parseFloat(item.prize)
        }
      }
      return prize
    },
    orderList () {
      const data = this.database.myOrder
      return data
    },
    carList () {
      const data = this.database.myCar
      for (const item of data) {
        if (typeof item.cart_attribute === 'string') {
          try {
            item.cartAttribute = JSON.parse(item.cart_attribute)
          } catch (e) {
            item.cartAttribute = {}
          }
        } else {
          item.cartAttribute = item.cart_attribute
        }
      }
      return data
    },
    tabBottomStyle () {
      if (this.options.type === 1) {
        return 'background: rgb(178, 164, 211)'
      } else if (this.options.type === 2) {
        return 'background: rgb(110, 193, 174)'
      } else if (this.options.type === 3) {
        return 'background: rgb(216, 237, 244)'
      }
    }
  },
  methods: {
    onDown (data) {
      const param = {}
      param.id = data.id
      param.activity_id = this.database.id
      param.access_token = Core.getAccessToken()
      postDownLoadFile({
        url: 'https://ssma.echao.com/auction/Auction/AuctionActivity/ActivityDiamond',
        data: param,
        method: 'post'
      })
    },
    onShowSchedule (type) {
      if (type) {
        this.modals.scheduleMode = true
      }
      const cTime = new Date().getTime() / 1000
      if (cTime < parseInt(this.database.info.place_order_start_time)) {
        // 未开始
        this.curProgress = 0
      } else if (cTime >= parseInt(this.database.info.place_order_start_time) && cTime < parseInt(this.database.info.place_order_end_time)) {
        // 竞拍阶段
        this.curProgress = 1
      } else if (cTime > parseInt(this.database.info.place_order_end_time) && cTime < parseInt(this.database.info.end_time)) {
        // 等待开盘
        this.curProgress = 2
      } else if (cTime >= parseInt(this.database.info.end_time)) {
        // 已经结束
        this.curProgress = 3
      }
      // this.curProgress = 3
      // 计算倒计时
      this.runCountTime()
    },
    runCountTime () {
      // 获取当前时间
      let date = new Date()
      let now = date.getTime()
      // 设置截止时间
      let end
      if (this.curProgress === 1) {
        end = parseInt(this.database.info.place_order_end_time) * 1000
      }
      if (this.curProgress === 2) {
        end = parseInt(this.database.info.end_time) * 1000
      }
      // end = '1583824750000'
      // 时间差
      let leftTime = end - now
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.timeLeft.d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        // 时
        let h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        this.timeLeft.h = h < 10 ? '0' + h : h
        // 分
        let m = Math.floor(leftTime / 1000 / 60 % 60)
        this.timeLeft.m = m < 10 ? '0' + m : m
        // 秒
        let s = Math.floor(leftTime / 1000 % 60)
        this.timeLeft.s = s < 10 ? '0' + s : s
      } else {
        this.timeLeft.d = 0
        this.timeLeft.h = '00'
        this.timeLeft.m = '00'
        this.timeLeft.s = '00'
      }
      // 等于0的时候不调用
      if (Number(this.timeLeft.d) === 0 && Number(this.timeLeft.h) === 0 && Number(this.timeLeft.m) === 0 && Number(this.timeLeft.s) === 0) {
        if (this.curProgress !== 3) { // 活动还未结束，刷新数据
          location.reload()
          return false
        }
        this.timeLeft.isEnd = true
        return false
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.runCountTime, 1000)
      }
    },
    onBack () {
      this.$router.back(-1)
    },
    onShowViewModal (type, index) {
      this.modals.viewModeIndex = index
      if (type === 'request') {
        this.modals.viewMode = true
      } else if (type === 'download') {
        this.modals.downloadScanMode = true
      }
    },
    onPrint () {
      window.print()
    },
    // 参与拍卖
    onRegistration () {
      this.modals.registrationModal = false
      this.$Message.success('登记成功！')
    },
    onCancelAuction (index) {
      if (index < 0 || index > this.database.list.length - 1) { return }
      // const data = this.database.list[index]
      this.database.list[index].auction = 0
      this.$Message.success('取消竞标成功！')
    },
    onAuction (index) {
      if (index < 0 || index > this.database.list.length - 1) { return }
      const data = this.database.list[index]
      this.database.list[index].auctionPrize = (parseFloat(data.prize) / parseFloat(data.size)).toFixed(2)
      this.database.list[index].auction = 11
      this.$Message.success('出价成功！')
    },
    onPlace (item) {
      const cartId = []
      cartId.push(item.id)
      Core('/Auction/Order/CartCreate', {cart_id: cartId}).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        this.$Modal.success({
          // title: title,
          content: '订单提交成功'
        })
      })
    },
    onPushCar (item) {
      const database = {
        activity_id: item.id,
        weight: item.weight
      }
      Core('/Auction/Cart/Change', {database}).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '加入购物车失败！')
        }
        this.$Message.success('加入购物车成功')
      })
    },
    switchType (type) {
      this.options.type = type
      if (type === 1) {
        this.getList(this.$route.query.type || 1)
      } else if (type === 2) {
        this.getMyCart()
      } else if (type === 3) {
        this.getMyOrder()
      }
    },
    getMyCart () {
      Core('/Auction/Cart/Listing').then(res => {
        if (res.data && res.data.list) {
          this.database.myCar = res.data.list
        }
      })
    },
    getMyOrder () {
      Core('/Auction/Order/ManagerListing').then(res => {
        if (res.data && res.data.list) {
          this.database.myOrder = res.data.list
        }
      })
    },
    getDetail (callback) {
      const param = {}
      param.activity_id = this.database.activity_id
      Core('/Auction/AuctionActivity/GetOne', param).then(res => {
        if (res.error_code) {
          return this.$Message.error(res.error_msg || '系统繁忙！')
        }
        if (res.data) {
          this.database.info = res.data
          callback && callback()
        }
      })
    },
    getList () {
      Core('/Auction/AuctionActivity/DiamondList', {package_id: this.database.id}).then(res => {
        if (res.data && res.data.list) {
          this.database.list = res.data.list
          for (const item of this.database.list) {
            this.$set(item, 'prize', 0)
            this.$set(item, 'auctionPrize', null)
          }
        }
      })
    }
  },
  filters: {
    unixToDate (unix, format, defValue) {
      if (/\d{13}/.test(unix)) {
        unix = parseInt(unix / 1000, 10)
      }
      let date = moment(/\d{10}/.test(unix) ? moment.unix(unix) : '').format(format || 'YYYY-MM-DD HH:mm:ss')
      return date === 'Invalid date' ? (defValue || '---') : date
    }
  },
  components: {
    MainHeader,
    MainFooter
  },
  mounted () {
    this.database.activity_id = this.$route.query.activity_id
    this.database.id = this.$route.query.id
    this.getDetail(() => {
      this.onShowSchedule()
    })
    this.getList()
    // this.getMyOrder()
    this.getMyCart()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  >>> .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >>> .vertical-center-modal .ivu-modal{
    top: 0;
  }
  >>> .schedule-modal .ivu-modal-body{padding: 0 5px}
  >>> .schedule-modal .ivu-modal-header{background: #ff9900; border-radius: 6px 6px 0 0;color: #fff}
  .schedule-item{text-align: left; border-bottom: 1px dotted rgb(137, 108, 57); padding: 10px 10px}
  .schedule-item:last-child{border: none}
  .schedule-item-name{color: rgb(137, 108, 57); font-size: 16px; font-weight: bold}
  .content{width: 100%; min-width: 800px; max-width: 1200px; padding-bottom: 30px; margin: 0 auto}

  .icon-search{width: 28px; height: 28px; background: rgb(245, 201, 140); border-radius: 5px; margin-left: 20px }

  .table{margin-top: 20px;}
  table {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.68);
    border-radius: 5px;
    width: 90%;
    background: #ccc;
    margin: 0 auto;
    border-collapse: collapse;/*border-collapse:collapse合并内外边距(去除表格单元格默认的2个像素内外边距*/
  }
  th,td {
    /*height: 25px;*/
    /*line-height: 50px;*/
    padding: 10px 0;
    text-align: center;
    /*border: 1px solid #ccc;*/
  }
  .tab-title{border: 1px solid #ccc;}
  .tab-list{border: 1px solid #ccc; border-top: none}
  th {
    background: #f8f8f9;
    font-weight: normal;
  }
  tr {
    background: #fff;
  }
  /*tr:hover {*/
    /*background: #cc0;*/
  /*}*/
  td a {
    color: #06f;
    text-decoration: none;
  }
  .icon-zip-box{width: 30px; height: 30px;background: rgb(221, 221, 221); border-radius: 2px; border: 3px solid rgb(241, 241, 241); box-sizing: border-box;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5); cursor: pointer; margin: 0 auto}
  .icon-zip-box img{width: 20px; height: 20px; margin-top: 2px;}

  .btns{ overflow: hidden; padding: 25px 0}
  .btns-back{float: left; font-size: 22px; color: #808695; font-weight: bold;position: relative; padding-left: 30px; cursor: pointer}
  .btns-back .icon-back{position: absolute; left: 0;}
  .btns-back span {color: #5cadff}
  .btns-item{float: right; margin-left: 20px;}
  .btns-time{float: right; text-align: center; color: #000; margin-top: -6px;}

  .download-info{background: rgb(217, 237, 247); border-radius: 5px; padding: 20px; box-shadow: 0 0 5px rgba(0, 0, 0, 0.68)}
  .download-title{display: flex; line-height: 35px;}
  .download-full-btn{ background: rgb(224, 224, 224); color: #249cdc; line-height: 35px; padding: 0 10px 0 30px;border-radius: 5px;position: relative; box-shadow: 0 0 5px rgba(0, 0, 0, 0.68);
  cursor: pointer;}
  .download-full-btn img{width: 20px; position: absolute;top: 8px; left: 10px}
  .download-desc{font-size: 20px;flex: 1; margin: 0 10px;}
  .download-desc span{color: #2b85e4}
  .download-excel-btn{}
  .download-weight{margin-top: 10px;}

  .bottom-tip{margin-top: 40px; font-size: 15px}
</style>



// WEBPACK FOOTER //
// src/components/ListDetails.vue